import { css, CSSProperties } from 'linaria';
import { themeClass } from 'ui/theme';
import { cn } from 'libs/classnames';
import { FunctionalComponent, h } from 'preact';

const verify = css`
	position: fixed;
	display: flex;
	flex-direction: column;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background: var(--background);
  z-index: 1000000000000;
`;

export const VerifyContainer: FunctionalComponent<{style?: CSSProperties}> = ({ children, style }) => (
	<div
		className={cn(verify, themeClass)}
		data-verify-container={'true'}
		style={style as any}
	>
		{children}
	</div>
);
